const DEVICE_TYPE_MAP = {
    'Aksioma01': 'Аксиома-01',
    'Aksioma03': 'Аксиома-03',
    'Karat307': 'Карат-307'
};

// ============================================
// ✅ Генерация карты программирования (Тип A - Стандартная)
// ============================================
export const generateProgrammingCard = async (node, city, street, house, toast) => {
    try {
        const { Document, Packer, Paragraph, TextRun, Table, TableRow, TableCell, WidthType, AlignmentType, BorderStyle } = await import('docx');
        const { saveAs } = await import('file-saver');

        const houseNumber = house.replace('Дом ', '').trim();
        const address = `${street}, дом ${houseNumber}`;

        const createCell = (text, bold = false) => {
            const textLines = (text || '—').split('\n');
            const textRuns = textLines.map((line, index) => {
                return new TextRun({
                    text: line,
                    break: index > 0 ? 1 : 0,
                    bold: bold,
                    size: 20,
                    font: 'Times New Roman'
                });
            });

            return new TableCell({
                children: [new Paragraph({ children: textRuns, alignment: AlignmentType.LEFT })],
                borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
                    left: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
                    right: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
                },
                margins: { top: 40, bottom: 40, left: 80, right: 80 }
            });
        };

        const hc = node.heatComputer || {};
        const hcTypeRu = DEVICE_TYPE_MAP[hc.deviceType] || hc.deviceType || '—';
        const hcName = hc.displayName || hc.deviceName || '—';

        const children = [
            new Paragraph({
                children: [new TextRun({ text: `Карта программирования тепловычислителя, установленного по адресу:`, bold: true, size: 24, font: 'Times New Roman' })],
                spacing: { after: 100 }
            }),
            new Paragraph({
                children: [new TextRun({ text: address + '.', size: 24, font: 'Times New Roman' })],
                spacing: { after: 200 }
            }),
            new Paragraph({
                children: [new TextRun({ text: `1. Тепловычислитель ${hcTypeRu}, описание: ${hcName}, заводской номер ${hc.factoryNumber || '—'}, дата выпуска ${hc.releaseDate || '—'}, дата поверки ${hc.verificationDate || '—'}, поверка действительна до ${hc.verificationValidUntil || '—'}.`, size: 22, font: 'Times New Roman' })],
                spacing: { after: 200 }
            }),
            new Paragraph({
                children: [new TextRun({ text: `2. Контрольная сумма (CRC16) настроек ${hc.crc16 || '—'}, дата последних изменений настроек ${hc.lastSettingsChange || '—'}. Перемычка изменения параметров находится в положении «${hc.jumperPosition || 'Изменения запрещены'}».`, size: 22, font: 'Times New Roman' })],
                spacing: { after: 200 }
            }),
            new Paragraph({
                children: [new TextRun({ text: '3. Датчики объёмного расхода:', bold: true, size: 22, font: 'Times New Roman' })],
                spacing: { after: 100 }
            }),
        ];

        const flowMeterHeaders = ['Переменная', 'Тип', 'Модель', 'Технические характеристики', 'Заводской номер', 'Дата поверки', 'Поверка действительна до'];
        children.push(new Table({
            rows: [
                new TableRow({ children: flowMeterHeaders.map(h => createCell(h, true)), tableHeader: true }),
                ...node.flowMeters.map(fm => new TableRow({
                    children: [createCell(fm.position), createCell(fm.deviceType), createCell(fm.deviceModel), createCell(fm.specs), createCell(fm.factoryNumber), createCell(fm.verificationDate), createCell(fm.verificationValidUntil)]
                }))
            ],
            width: { size: 100, type: WidthType.PERCENTAGE }
        }));

        children.push(new Paragraph({ children: [new TextRun({ text: '4. Датчики температуры:', bold: true, size: 22, font: 'Times New Roman' })], spacing: { before: 200, after: 100 } }));
        const tempHeaders = ['Переменная', 'Тип', 'Модель', 'Технические характеристики', 'Заводской номер', 'Дата поверки', 'Поверка действительна до'];
        children.push(new Table({
            rows: [
                new TableRow({ children: tempHeaders.map(h => createCell(h, true)), tableHeader: true }),
                ...node.temperatureSensors.map(ts => new TableRow({
                    children: [createCell(ts.position), createCell(ts.deviceType), createCell(ts.deviceModel), createCell(ts.specs), createCell(ts.factoryNumber), createCell(ts.verificationDate), createCell(ts.verificationValidUntil)]
                }))
            ],
            width: { size: 100, type: WidthType.PERCENTAGE }
        }));

        children.push(new Paragraph({ children: [new TextRun({ text: '5. Датчики давления:', bold: true, size: 22, font: 'Times New Roman' })], spacing: { before: 200, after: 100 } }));
        children.push(new Table({
            rows: [
                new TableRow({ children: tempHeaders.map(h => createCell(h, true)), tableHeader: true }),
                ...node.pressureSensors.map(ps => new TableRow({
                    children: [createCell(ps.position), createCell(ps.deviceType), createCell(ps.deviceModel), createCell(ps.specs), createCell(ps.factoryNumber), createCell(ps.verificationDate), createCell(ps.verificationValidUntil)]
                }))
            ],
            width: { size: 100, type: WidthType.PERCENTAGE }
        }));

        children.push(
            new Paragraph({ children: [new TextRun({ text: '6. Алгоритм учета тепловой энергии:', bold: true, size: 22, font: 'Times New Roman' })], spacing: { before: 200, after: 100 } })
        );

        // ✅ ИСПРАВЛЕНИЕ: Корректная обработка переносов строк (\n) в алгоритме
        const formulaText = hc.algorithmFormula || '—';
        const formulaLines = formulaText.split('\n');
        const formulaRuns = formulaLines.map((line, index) => {
            return new TextRun({
                text: index === 0 ? `Формулы расчета: ${line};` : line,
                break: index > 0 ? 1 : 0,
                size: 22,
                font: 'Times New Roman'
            });
        });
        children.push(new Paragraph({ children: formulaRuns, spacing: { after: 200 } }));

        children.push(
            new Paragraph({ children: [new TextRun({ text: `7. Параметр холодного источника принят постоянным в течение всего года и составляет ${hc.coldSourceParam || '—'}.`, size: 22, font: 'Times New Roman' })], spacing: { after: 200 } }),
            new Paragraph({ children: [new TextRun({ text: `8. Максимальная погрешность измерения значений тепловой энергии теплоузла в целом не превышает 5%.`, size: 22, font: 'Times New Roman' })], spacing: { after: 200 } }),
            new Paragraph({ children: [new TextRun({ text: `9. Глубина архивов тепловычислителя составляет ${hc.archiveDepth || '—'}.`, size: 22, font: 'Times New Roman' })], spacing: { after: 200 } }),
            new Paragraph({ children: [new TextRun({ text: `10. Дата последующей поверки теплоузла в целом: ${node.oplombirovanValidUntil || '—'}.`, size: 22, font: 'Times New Roman' })], spacing: { after: 200 } }),
            new Paragraph({ children: [new TextRun({ text: `Дата составления карты программирования тепловычислителя: ${new Date().toLocaleDateString('ru-RU')}`, size: 22, font: 'Times New Roman' })], spacing: { after: 400 } }),
            new Paragraph({ children: [new TextRun({ text: 'Ответственный за достоверность приведенных данных:', bold: true, size: 22, font: 'Times New Roman' })], spacing: { after: 100 } }),
            new Paragraph({ children: [new TextRun({ text: `Директор ${node.responsibleOrg || '_______________'} ___________ _______ / ${node.responsibleName || '_______________'} /`, size: 22, font: 'Times New Roman' })], spacing: { after: 200 } }),
            new Paragraph({ children: [new TextRun({ text: `Директор ${node.managementOrg || '_______________'} ____________________ / ${node.managementName || '_______________'} /`, size: 22, font: 'Times New Roman' })], spacing: { after: 200 } })
        );

        const doc = new Document({
            sections: [{
                properties: { page: { margin: { top: 1440, right: 1080, bottom: 1440, left: 1080 } } },
                children
            }]
        });

        const blob = await Packer.toBlob(doc);
        const fileName = `Карта_программирования_${city}_${street}_${houseNumber}_${node.name}.docx`.replace(/[^\wа-яА-ЯёЁ.-]/g, '_');
        saveAs(blob, fileName);
        toast.success('Карта программирования (Тип A) сформирована');
        return true;
    } catch (err) {
        console.error('❌ Ошибка генерации карты Тип A:', err);
        toast.error('Не удалось сформировать карту: ' + err.message);
        return false;
    }
};

// ============================================
// ✅ Генерация карты программирования (Тип B - Приложение А)
// ============================================
export const generateProgrammingCardTypeB = async (node, city, street, house, toast) => {
    try {
        const { Document, Packer, Paragraph, TextRun, Table, TableRow, TableCell, WidthType, AlignmentType, BorderStyle } = await import('docx');
        const { saveAs } = await import('file-saver');

        const houseNumber = house.replace('Дом ', '').trim();
        const hc = node.heatComputer || {};
        const hcTypeRu = DEVICE_TYPE_MAP[hc.deviceType] || hc.deviceType || 'Аксиома-03';
        const hcFactoryNumber = hc.factoryNumber || '______';

        const createCell = (text, bold = false, align = AlignmentType.LEFT, colSpan = 1) => {
            const textLines = (text || '—').split('\n');
            const textRuns = textLines.map((line, index) => {
                return new TextRun({
                    text: line,
                    break: index > 0 ? 1 : 0,
                    bold: bold,
                    size: 20,
                    font: 'Times New Roman'
                });
            });

            return new TableCell({
                children: [new Paragraph({ children: textRuns, alignment: align })],
                columnSpan: colSpan,
                borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
                    left: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
                    right: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
                },
                margins: { top: 40, bottom: 40, left: 80, right: 80 }
            });
        };

        const children = [];

        // Заголовок документа
        children.push(
            new Paragraph({ children: [new TextRun({ text: 'ПРИЛОЖЕНИЕ А', bold: true, size: 24, font: 'Times New Roman' })], alignment: AlignmentType.CENTER, spacing: { after: 100 } }),
            new Paragraph({ children: [new TextRun({ text: 'к паспорту АСС.000102.001 ПС', size: 24, font: 'Times New Roman' })], alignment: AlignmentType.CENTER, spacing: { after: 200 } }),
            new Paragraph({ children: [new TextRun({ text: `Настройка тепловычислителя ${hcTypeRu}, зав. № ${hcFactoryNumber}`, bold: true, size: 24, font: 'Times New Roman' })], alignment: AlignmentType.CENTER, spacing: { after: 300 } })
        );

        // Таблица 1: Общие настройки
        const generalSettings = [
            ['Алгоритм учёта ТЭ', hc.algorithmFormula || 'Схема измерения (СИ): 2\nФормулы теплоучёта (ФТ): 0\ndt = t1-t2\ndP=P1-P2\nM1=p1V1\nM2=p2V2\ndGm=M1-M2\nQ1=M1 * (t1-t2)'],
            ['Режим работы', 'Тепловычислитель'],
            ['Действия при НС температуры', 'Авария'],
            ['Действия при НС ΔT < 3 °C', 'Авария'],
            ['Действия при НС расход', 'Авария'],
            ['Действия при НС давления', 'Подстановка'],
            ['Время интегрирования', '2 минуты'],
            ['Дата измен. настроек', hc.lastSettingsChange || 'дд.мм.гггг']
        ];

        children.push(new Table({
            rows: generalSettings.map(row => new TableRow({
                children: [createCell(row[0], true), createCell(row[1], false)]
            })),
            width: { size: 100, type: WidthType.PERCENTAGE }
        }));
        children.push(new Paragraph({ text: '', spacing: { before: 200, after: 200 } }));

        // ✅ ИСПРАВЛЕНИЕ: Таблицы датчиков теперь идентичны Типу А (7 колонок)

        // 1. Датчики объёмного расхода
        children.push(new Paragraph({ children: [new TextRun({ text: 'Датчики объёмного расхода:', bold: true, size: 22, font: 'Times New Roman' })], spacing: { before: 200, after: 100 } }));
        const flowHeaders = ['Переменная', 'Тип', 'Модель', 'Технические характеристики', 'Заводской номер', 'Дата поверки', 'Поверка действительна до'];
        children.push(new Table({
            rows: [
                new TableRow({ children: flowHeaders.map(h => createCell(h, true)), tableHeader: true }),
                ...(node.flowMeters || []).map(fm => new TableRow({
                    children: [
                        createCell(fm.position),
                        createCell(fm.deviceType),
                        createCell(fm.deviceModel),
                        createCell(fm.specs), // createCell сам обработает \n внутри specs
                        createCell(fm.factoryNumber),
                        createCell(fm.verificationDate),
                        createCell(fm.verificationValidUntil)
                    ]
                }))
            ],
            width: { size: 100, type: WidthType.PERCENTAGE }
        }));

        // 2. Датчики температуры
        children.push(new Paragraph({ children: [new TextRun({ text: 'Датчики температуры:', bold: true, size: 22, font: 'Times New Roman' })], spacing: { before: 200, after: 100 } }));
        const tempHeaders = ['Переменная', 'Тип', 'Модель', 'Технические характеристики', 'Заводской номер', 'Дата поверки', 'Поверка действительна до'];
        children.push(new Table({
            rows: [
                new TableRow({ children: tempHeaders.map(h => createCell(h, true)), tableHeader: true }),
                ...(node.temperatureSensors || []).map(ts => new TableRow({
                    children: [
                        createCell(ts.position),
                        createCell(ts.deviceType),
                        createCell(ts.deviceModel),
                        createCell(ts.specs),
                        createCell(ts.factoryNumber),
                        createCell(ts.verificationDate),
                        createCell(ts.verificationValidUntil)
                    ]
                }))
            ],
            width: { size: 100, type: WidthType.PERCENTAGE }
        }));

        // 3. Датчики давления
        children.push(new Paragraph({ children: [new TextRun({ text: 'Датчики давления:', bold: true, size: 22, font: 'Times New Roman' })], spacing: { before: 200, after: 100 } }));
        const pressHeaders = ['Переменная', 'Тип', 'Модель', 'Технические характеристики', 'Заводской номер', 'Дата поверки', 'Поверка действительна до'];
        children.push(new Table({
            rows: [
                new TableRow({ children: pressHeaders.map(h => createCell(h, true)), tableHeader: true }),
                ...(node.pressureSensors || []).map(ps => new TableRow({
                    children: [
                        createCell(ps.position),
                        createCell(ps.deviceType),
                        createCell(ps.deviceModel),
                        createCell(ps.specs),
                        createCell(ps.factoryNumber),
                        createCell(ps.verificationDate),
                        createCell(ps.verificationValidUntil)
                    ]
                }))
            ],
            width: { size: 100, type: WidthType.PERCENTAGE }
        }));

        const doc = new Document({
            sections: [{
                properties: { page: { margin: { top: 1440, right: 1080, bottom: 1440, left: 1080 } } },
                children
            }]
        });

        const blob = await Packer.toBlob(doc);
        const fileName = `Карта_программирования_ТипB_${city}_${street}_${houseNumber}_${node.name}.docx`.replace(/[^\wа-яА-ЯёЁ.-]/g, '_');
        saveAs(blob, fileName);
        toast.success('Карта программирования (Тип B) сформирована');
        return true;
    } catch (err) {
        console.error('❌ Ошибка генерации карты Тип B:', err);
        toast.error('Не удалось сформировать карту: ' + err.message);
        return false;
    }
};